





















































import {Component, Prop} from "vue-property-decorator";
import {GuardStore} from "@/guards/store";
import {RouteConfig, RouteRecord} from "vue-router";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";

@Component({
  name: 'SideBarContent',
})
export default class extends mixins(CommonMixin) {
  @Prop({default: () => true})
  private visibleTitle!: boolean;

  private routeOnlyOneChild: RouteConfig | undefined;

  openKeys: any = [];

  get _visibleTitle(): boolean {
    return this.visibleTitle;
  }

  get routes(): Array<RouteConfig> {
    return GuardStore.routes;
  }

  get rootSubmenuKeys() {
    return GuardStore.routes
        .filter((route: RouteConfig) => route.meta?.showRoot)
        .map((route: RouteConfig) => route.name);
  }

  get selectedRouteKeys(): string[] {
    return [this.$route.name as string];
  }

  get openedRouteKeys(): string[] {
    const parentRoot: RouteRecord | undefined = this.$route.matched.find((item: RouteRecord) => item.parent === undefined);
    return parentRoot?.name ? [parentRoot.name] : [];
  }

  private showRoot(route: RouteConfig): boolean {
    return route.meta && route.meta.showRoot;
  }

  private showingChildNumber(route: RouteConfig): number {
    if (!route.children || !route.children.length) return 0;
    const showingChildren = route.children.filter((item: RouteConfig) => !(item.meta && item.meta?.hidden));
    return showingChildren.length;
  }

  private theRouteOnlyOneChild(route: RouteConfig): RouteConfig | undefined {
    if (this.showingChildNumber(route) > 1) {
      this.routeOnlyOneChild = undefined;
      return this.routeOnlyOneChild;
    }
    if (!route.children || !route.children.length) {
      this.routeOnlyOneChild = {...route};
      return this.routeOnlyOneChild;
    }
    this.routeOnlyOneChild = route.children?.find((item: RouteConfig) => (!item.meta || !item.meta?.hidden));
    return this.routeOnlyOneChild;
  }

  private isActiveRoute(route: RouteConfig): boolean {
    return this.$route.matched.some((item: RouteRecord) => item.name === route.name);
  }

  onOpenChange(openKeys) {
    const latestOpenKey = openKeys.find(key => this.openKeys.indexOf(key) === -1);
    if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      this.openKeys = openKeys;
    } else {
      this.openKeys = latestOpenKey ? [latestOpenKey] : [];
    }
  }
}
